module.exports = __webpack_public_path__ + "static/media/Karte2.b06dcf64.png";